import React, { useState, useEffect } from "react";
import ReactTable from "../components/ReactTable";
import axios from "axios";
import moment from "moment";

const Table = () => {
  const [documentData, setDocumentData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [uniqData, setUniqData] = useState([]);

  const fetchDocumentData = async () => {
    try {
      const response = await axios.get(
        "https://visualtable.shaleprofile.com/api/documentData"
      );

      if (response.status === 200) {
        const documentData = response?.data?.data || [];

        //latest date

        const sortedData = documentData.sort(
          (a, b) => new Date(b.US_PublishDate) - new Date(a.US_PublishDate)
        );

        // Get the first item from the sorted data (most recent record)
        const latestRecord = new Date(sortedData[0]?.US_PublishDate)
          .toISOString()
          .slice(0, 10);
        // const lastRecordDate = documentData[documentData.length - 1];
        // const latestRecord = lastRecordDate?.US_PublishDate;

        const previousYearDate = new Date(latestRecord); // Convert to Date object using US_PublishDate
        previousYearDate.setFullYear(previousYearDate.getFullYear() - 1); // Subtract one year

        console.log("Previous Year Date:", latestRecord); // Output in 'YYYY-MM-DD' format

        const compareCuurentDate = latestRecord;
        const compareOneYearAgeDate = previousYearDate;

        console.log("targetDate one year:llll", compareOneYearAgeDate);
        ///current_week---------

        // Define the target date to compare against
        const targetDate = compareCuurentDate;
        const targetPreviosYearDate = compareOneYearAgeDate;

        // Step 1: Filter the data based on the target date
        const filteredDataCurrent_Rig = documentData.filter((item) => {
          const itemDate = new Date(item.US_PublishDate);
          const formattedItemDate = itemDate.toISOString().slice(0, 10); // Convert to 'YYYY-MM-DD'

          return formattedItemDate === targetDate; // Compare formatted dates
        });


        // Step 2: Get unique counties (with the highest rig count for each county)
        const uniqueCountyMap = new Map();

        filteredDataCurrent_Rig.forEach((item) => {
          if (!item.county || item.current_rigs == null) return;

          // If the county doesn't exist or the current rigs are greater than the existing value
          const existingCounty = uniqueCountyMap.get(item.county);
          if (
            !existingCounty ||
            item.current_rigs > existingCounty.current_rigs
          ) {
            uniqueCountyMap.set(item.county, item); // Keep the record with the highest rigs count
          }
        });

        // Step 3: Get the array of unique county records
        const uniqueCurrentCountyRigCounts = Array.from(
          uniqueCountyMap.values()
        );

        // Log the filtered and unique counties
        console.log(
          "Unique counties with rig counts for the target date (" +
          targetDate +
          "):",
          uniqueCurrentCountyRigCounts
        );

        const getCountyWithHighestRigs = (data) => {
          const countyMap = new Map();

          // Loop through the data to process each item
          data.forEach((item) => {
            if (!item.county || item.current_rigs == null) return; // Skip invalid entries

            // If the county already exists, check if we need to update the rig count
            const existing = countyMap.get(item.county);
            if (
              !existing || // If the county is not in the map yet
              item.current_rigs > existing.current_rigs // Or if the current county has a higher rig count
            ) {
              countyMap.set(item.county, item); // Update the map with the new highest rig count for this county
            }
          });

          // Return the counties with the highest rig counts
          return Array.from(countyMap.values());
        };

        // Assuming documentData is populated from your API response
        // const documentData = response?.data?.data || [];

        // Get the counties with the highest rig count
        const highestRigsCounties = getCountyWithHighestRigs(documentData);

        // The result is an array of counties with the highest rig counts
        console.log(
          "Counties with the highest rig counts:",
          highestRigsCounties
        );

        // Function to get highest `current_rigs` data for unique counties in a date range
        const getHighestRigsForUniqueCounties = (startDate, endDate) => {
          // Filter data by date range
          const filteredData = documentData.filter((item) => {
            const usPublishDate = new Date(item.US_PublishDate); // Convert to Date object
            return usPublishDate >= startDate && usPublishDate <= endDate; // Within date range
          });

          // Create a map to store highest rigs data for each unique county
          const countyMap = new Map();

          filteredData.forEach((item) => {
            if (!item.county || item.current_rigs == null) return; // Skip invalid entries

            const existing = countyMap.get(item.county);
            if (!existing || item.current_rigs > existing.current_rigs) {
              countyMap.set(item.county, item); // Update with the highest `current_rigs` data
            }
          });

          // Return the map values as an array
          return Array.from(countyMap.values());
        };

        // Function to get highest or lowest `current_rigs` data for unique counties in a date range
        const getCountyDataByRigs = (startDate, endDate, type = "highest") => {
          console.log("Counties with the highest startDate:--", startDate);
          const filteredData = documentData.filter((item) => {
            const usPublishDate = new Date(item.US_PublishDate);
            return usPublishDate >= startDate && usPublishDate <= endDate; // Filter by date range
          });

          const countyMap = new Map();

          filteredData.forEach((item) => {
            if (!item.county || item.current_rigs == null) return; // Skip invalid entries

            const existing = countyMap.get(item.county);

            if (
              !existing ||
              (type === "highest" &&
                item.current_rigs > existing.current_rigs) ||
              // (type === "lowest" &&
              //   item?.DrillFor === "Oil" &&
              //   item.current_rigs?.US_PublishDate > existing.US_PublishDate)
              (type === "lowest" && item.current_rigs < existing.current_rigs)
            ) {
              countyMap.set(item.county, item); // Keep the row with the desired value
            }
          });

          return Array.from(countyMap.values());
        };

        // 1. Current Year Data: From "2023-11-27" to "2024-11-27"
        const currentYearEndDate = new Date(compareCuurentDate);
        const currentYearStartDate = new Date(currentYearEndDate);
        currentYearStartDate.setFullYear(currentYearEndDate.getFullYear() - 1);

        const highestRigsCurrentYear = uniqueCurrentCountyRigCounts;

        // Define the target date (e.g., "2024-12-22")

        // Convert the target date to a Date object
        const targetDateObj = new Date(targetPreviosYearDate);

        // Step 1: Calculate the start date for the last 52 weeks
        const startDate = new Date(targetDateObj);
        startDate.setDate(targetDateObj.getDate() - 52 * 7); // Subtract 25 weeks (7 days per week)

        // Step 2: Filter the data for the last 25 weeks
        const filteredData25Weeks = documentData.filter((item) => {
          const itemDate = new Date(item.US_PublishDate);
          const formattedItemDate = itemDate.toISOString().slice(0, 10); // Convert to 'YYYY-MM-DD'

          // Return true if the date is within the last 52 weeks
          return (
            formattedItemDate >= startDate.toISOString().slice(0, 10) &&
            formattedItemDate <=
            targetPreviosYearDate.toISOString().slice(0, 10)
          );
        });

        // Step 3: Get unique counties with the highest rig count in the last 52 weeks
        const countyRigMap1 = new Map();

        filteredData25Weeks.forEach((item) => {
          if (!item.county || item.current_rigs == null) return; // Skip invalid entries

          const existingCounty = countyRigMap1.get(item.county);

          // If the county doesn't exist or we need to update the record based on the highest rig count
          if (!existingCounty) {
            countyRigMap1.set(item.county, item); // Keep the record with the highest rigs count for that county
          }
        });

        // Step 4: Convert to array and log the unique counties with their rig counts
        const uniqueCountyRigCounts52Week = Array.from(countyRigMap1.values());
        console.log(
          "Unique counties with rig counts for the last 25 weeks:",
          uniqueCountyRigCounts52Week
        );

        // 3. Previous Week Data
        const previousWeekEndDate = new Date(compareCuurentDate); // Current date
        const previousWeekStartDate = new Date(previousWeekEndDate);
        previousWeekStartDate.setDate(previousWeekEndDate.getDate() - 7); // Subtract 7 days

        const highestRigsPreviousWeek = getCountyDataByRigs(
          previousWeekStartDate,
          previousWeekEndDate
          // "highest"
        );

        // Define the current date (in this case "2024-12-22")
        // const compareCurrentDate = "2024-12-22";

        // Convert the date string to a Date object
        const currentDate = new Date(targetDate);

        // Step 1: Calculate the start of the current week (Monday)
        const currentDay = currentDate.getDay();
        const daysToMonday = currentDay === 0 ? 6 : currentDay - 1; // If Sunday (0), subtract 6 to get Monday
        const startOfCurrentWeek = new Date(currentDate);
        startOfCurrentWeek.setDate(currentDate.getDate() - daysToMonday); // Set to Monday of the current week

        // Step 2: Calculate the end of the current week (Sunday)
        const endOfCurrentWeek = new Date(startOfCurrentWeek);
        endOfCurrentWeek.setDate(startOfCurrentWeek.getDate() + 6); // Add 6 days to get Sunday

        // Step 3: Calculate the start of the previous week (7 days before Monday of current week)
        const startOfPreviousWeek = new Date(startOfCurrentWeek);
        startOfPreviousWeek.setDate(startOfCurrentWeek.getDate() - 7); // Subtract 7 days to get the previous week's Monday

        // Step 4: Calculate the end of the previous week (7 days before Sunday of current week)
        const endOfPreviousWeek = new Date(endOfCurrentWeek);
        endOfPreviousWeek.setDate(endOfCurrentWeek.getDate() - 7); // Subtract 7 days to get the previous week's Sunday

        // Log the previous week start and end dates for debugging
        console.log(
          "Start of Previous Week:",
          startOfPreviousWeek.toISOString().slice(0, 10)
        );
        console.log(
          "StartEnd of Previous Week:",
          endOfPreviousWeek.toISOString().slice(0, 10)
        );

        // Step 5: Filter the data for the previous week
        const filteredPreviousWeekData = documentData.filter((item) => {
          const itemDate = new Date(item.US_PublishDate);
          const formattedItemDate = itemDate.toISOString().slice(0, 10); // Convert to 'YYYY-MM-DD'

          return (
            formattedItemDate >=
            startOfPreviousWeek.toISOString().slice(0, 10) &&
            formattedItemDate <= endOfPreviousWeek.toISOString().slice(0, 10)
          ); // Only include records in the previous week
        });

        // Step 6: Calculate the unique rig count for each county in the previous week
        const countyRigMap = new Map();

        filteredPreviousWeekData.forEach((item) => {
          if (!item.county || item.current_rigs == null) return; // Skip invalid entries
          const existingCounty = countyRigMap.get(item.county);

          // If the county is not in the map or we need to update it based on the highest rig count for the previous week
          if (
            !existingCounty ||
            item.current_rigs > existingCounty.current_rigs
          ) {
            countyRigMap.set(item.county, item); // Keep the record with the highest rig count for that county
          }
        });

        // Step 7: Get the unique counties and their rig counts for the previous week
        const uniqueCountyRigCountsPriorWeek = Array.from(
          countyRigMap.values()
        );


        ////////////////privios week----------------

        console.log("checkpriviosweekdata", highestRigsPreviousWeek);
        // 4. Last 52 Weeks: Highest and Lowest Data
        const fiftyTwoWeeksEndDate = new Date(compareCuurentDate); // Current date
        const fiftyTwoWeeksStartDate = new Date(fiftyTwoWeeksEndDate);
        fiftyTwoWeeksStartDate.setDate(fiftyTwoWeeksEndDate.getDate() - 52 * 7); // Subtract 52 weeks

        const highestRigsFiftyTwoWeeks = getCountyDataByRigs(
          fiftyTwoWeeksStartDate,
          fiftyTwoWeeksEndDate,
          "highest"
        );
        const lowestRigsFiftyTwoWeeks = getCountyDataByRigs(
          fiftyTwoWeeksStartDate,
          fiftyTwoWeeksEndDate,
          "lowest"
        );

        console.log(
          "lowestRigsFiftyTwoWeeks...",
          fiftyTwoWeeksStartDate,
          fiftyTwoWeeksEndDate
        );

        const dummyArray = [];

        const getRigValueForCounty = (
          county,
          rigsData,
          uniqueCountyRigCounts52Week
        ) => {
          const countyData = rigsData.find((item) => item.county === county);
          return countyData ? countyData.current_rigs : null;
        };

        // Loop through unique counties from the current year's highest rigs and create objects
        uniqueCurrentCountyRigCounts.forEach((filteredDataCurrent_Rig) => {
          const county = filteredDataCurrent_Rig.county;

          // Get rigs data for the current county from the previous data sets
          const uniqueRigCountsPriorWeek = getRigValueForCounty(
            county,
            uniqueCountyRigCountsPriorWeek
          );
          const highestRigsPreviousYearValue = getRigValueForCounty(
            county,
            uniqueCountyRigCounts52Week
          );
          const highestRigsFiftyTwoWeeksValue = getRigValueForCounty(
            county,
            highestRigsFiftyTwoWeeks
          );
          const lowestRigsFiftyTwoWeeksValue = getRigValueForCounty(
            county,
            lowestRigsFiftyTwoWeeks
          );

          console.log("checkvalie52weeks", lowestRigsFiftyTwoWeeksValue);

          // Calculate the changes, if any value is null, set change to null (or 0 if preferred)
          const priorWeekChange =
            uniqueRigCountsPriorWeek !== null
              ? filteredDataCurrent_Rig.current_rigs - uniqueRigCountsPriorWeek
              : filteredDataCurrent_Rig.current_rigs;
          // const priorYearChange =
          //   highestRigsPreviousYearValue !== null
          //     ? filteredDataCurrent_Rig.current_rigs -
          //       highestRigsPreviousYearValue
          //     : null;

          const priorYearChange =
            highestRigsPreviousYearValue !== null
              ? filteredDataCurrent_Rig.current_rigs -
              highestRigsPreviousYearValue
              : filteredDataCurrent_Rig.current_rigs;

          const wkHighChange =
            highestRigsFiftyTwoWeeksValue !== null
              ? filteredDataCurrent_Rig.current_rigs -
              highestRigsFiftyTwoWeeksValue
              : filteredDataCurrent_Rig.current_rigs;
          const wkLowChange =
            lowestRigsFiftyTwoWeeksValue !== null
              ? filteredDataCurrent_Rig.current_rigs -
              lowestRigsFiftyTwoWeeksValue
              : filteredDataCurrent_Rig.current_rigs;

          // Push the object for this county into the dummyArray
          dummyArray.push({
            basin: filteredDataCurrent_Rig.basin,
            state: filteredDataCurrent_Rig.state,
            county: filteredDataCurrent_Rig?.county,
            current_rigs: filteredDataCurrent_Rig.current_rigs,
            prior_week: uniqueRigCountsPriorWeek,
            prior_year: highestRigsPreviousYearValue,
            "52_wk_high": highestRigsFiftyTwoWeeksValue,
            "52_wk_low": lowestRigsFiftyTwoWeeksValue,
            prior_wk_chg: priorWeekChange,
            prior_yr_chg: priorYearChange,
            "52_wk_high_chg": wkHighChange,
            "52_wk_low_chg": wkLowChange,
          });
        });

        console.log(dummyArray);
        setUniqData(dummyArray);
        console.log(
          "dummyArray for Unique Counties (Last 52 Weeks):",
          dummyArray
        );
      } else {
        setError(response?.data?.message);
      }
    } catch (error) {
      setError(error.message);
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocumentData();
  }, []);

  const columns = [
    {
      field: "basin",
      header: "Basin",
      sortable: true,
    },
    {
      field: "state",
      header: "State",
      sortable: true,
    },
    {
      field: "county",
      header: "County",
      sortable: true,
    },

    {
      field: "current_rigs",
      header: "Current Rigs",
      sortable: true,
    },
    {
      field: "prior_week",
      header: "Prior Week",
      sortable: true,
    },
    {
      field: "prior_year",
      header: "Prior Year",
      sortable: true,
    },
    {
      field: "52_wk_high",
      header: "52 Wk High",
      sortable: true,
    },
    {
      field: "52_wk_low",
      header: "52 Wk Low",
      sortable: true,
    },
    {
      field: "prior_wk_chg",
      header: "Prior Wk Chg",
      sortable: true,
    },
    {
      field: "prior_yr_chg",
      header: "Prior Yr Chg",
      sortable: true,
    },
    {
      field: "52_wk_high_chg",
      header: "52 Wk High Chg",
      sortable: true,
    },
    {
      field: "52_wk_low_chg",
      header: "52 Wk Low Chg",
      sortable: true,
    },
  ];

  console.log("Updated Document Data", uniqData);

  return (
    <div>
      <ReactTable data={uniqData} columns={columns} />
    </div>
  );
};

export default Table;
